import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '../../lib/utils'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export const EmptyState = ({ icon: Icon, title, description, action, className }: EmptyStateProps) => {
  return (
    <div className={cn('text-center py-16', className)}>
      {Icon && <Icon size={40} className="mx-auto text-gray-200 mb-4" />}
      <h2 className="text-base font-medium text-gray-900 mb-1">{title}</h2>
      {description && <p className="text-sm text-gray-400 mb-6">{description}</p>}
      {action}
    </div>
  )
}
